module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-1.5415ab0d.svg";